const GET_URL_TO_DOWNLOAD = "GET_URL_TO_DOWNLOAD"
const GET_URL_TO_DOWNLOAD_SUCCESS = "GET_URL_TO_DOWNLOAD_SUCCESS"
const GET_URL_TO_DOWNLOAD_FAIL = "GET_URL_TO_DOWNLOAD_FAIL"

const BASE_ENDPOINT = '/Documentation/';
const initialValues = {
    loading: false,
    hasError: false,
    data: null
};

const societiesTaxProfile = (state = initialValues, action) => {

    switch (action.type) {

        case GET_URL_TO_DOWNLOAD: {
            return {
                ...state,
                loading: true,
            }
        }

        case GET_URL_TO_DOWNLOAD_SUCCESS: {
            return {
                ...state,
                data: action.payload.data,
                loading: false,
            }
        }

        case GET_URL_TO_DOWNLOAD_FAIL: {
            return {
                ...state,
                loading: false,
                hasError: true,
            };
        }

        default: {
            return state;
        }

    }
};

export const getURLToDownload = (code) => {

    return {
        type: GET_URL_TO_DOWNLOAD,
        payload: {
            request: {
                method: "GET",
                url: BASE_ENDPOINT + `TaxProfile?code=${code}`
            },
        },
    };
};

export default societiesTaxProfile;